import * as moment from 'moment';

export function isEmpty(obj: any) {
  if (Array.isArray(obj)) {
    return obj.length === 0;
  } else if (typeof obj === 'string') {
    return obj.trim().length === 0;
  } else if (typeof obj === 'object') {
    return obj === null || Object.keys(obj).length === 0;
  } else {
    return obj === null || typeof obj === 'undefined';
  }
}
export function isEmail(email: any) {
  const rule = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return rule.test(String(email).toLowerCase());
}

export function isValidDate(date: string, format: string) {
  if (format) {
    return moment(date, format, true).isValid();
  }
  return moment(date).isValid();
}
